import * as XLSX from "xlsx";

/**
 * Exporta un arreglo de objetos a un archivo Excel
 * @param data - Arreglo de objetos a exportar
 * @param fileName - Nombre del archivo Excel (sin extensión)
 * @param sheetName - Nombre de la hoja del Excel (por defecto "Data")
 */
export const exportToExcel = (
  fileName: string = "export",
  sheetsFiles: { data: any[]; sheetName: string }[] = []
): void => {
  if (!sheetsFiles || sheetsFiles.length === 0) {
    console.warn("No hay datos para exportar");
    return;
  }

  try {
    // Crear un libro de trabajo
    // const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    sheetsFiles.forEach(({ data, sheetName }) => {
      const sheetData = XLSX.utils.json_to_sheet(data || []);
      XLSX.utils.book_append_sheet(workbook, sheetData, sheetName);
    });
    // if (Array.isArray(sheetName)) {
    //   sheetName.forEach((name, index) => {
    //     const sheetData = XLSX.utils.json_to_sheet(data[index] || []);
    //     XLSX.utils.book_append_sheet(workbook, sheetData, name);
    //   });
    // } else {
    //   XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    // }

    // // Ajustar ancho de columnas automáticamente
    // const colWidths = Object.keys(data[0]).map((key) => ({
    //   wch: Math.max(key.length, 15),
    // }));
    // worksheet["!cols"] = colWidths;

    // Descargar el archivo
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error al exportar a Excel:", error);
  }
};

/**
 * Exporta un arreglo de objetos a CSV
 * @param data - Arreglo de objetos a exportar
 * @param fileName - Nombre del archivo CSV (sin extensión)
 */
export const exportToCSV = (data: any[], fileName: string = "export"): void => {
  if (!data || data.length === 0) {
    console.warn("No hay datos para exportar");
    return;
  }

  try {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    XLSX.writeFile(workbook, `${fileName}.csv`);
  } catch (error) {
    console.error("Error al exportar a CSV:", error);
  }
};
